import { render } from "./TheExtensionCard.vue?vue&type=template&id=20cfeb84"
import script from "./TheExtensionCard.vue?vue&type=script&lang=js"
export * from "./TheExtensionCard.vue?vue&type=script&lang=js"
script.render = render

export default script